export default __webpack_public_path__ + "cd9e6b87789a0f3f7c9314d2b2bd701e.png";